import React from 'react';
import {usePages} from "@ignitesales/neuro-application";
import {useThemeSettings} from "../hooks/useThemeSettings.mjs";
import * as PropTypes from "prop-types";

const DialogueProgressBar = ({ className, ProgressBarComponent, showBackground = false }) => {
    const { progress } = usePages();
    const { getSurveyThemeConfigs } = useThemeSettings();
    const surveyPageThemeConfigs = getSurveyThemeConfigs();
    const useProgressBar = surveyPageThemeConfigs.hasOwnProperty('useProgressBar') ? surveyPageThemeConfigs.useProgressBar : true;

    return useProgressBar && <ProgressBarComponent progress={progress} className={className} showBackground={showBackground} />;
};
DialogueProgressBar.propTypes = {
    className: PropTypes.string,
    ProgressBarComponent: PropTypes.any
};
export default DialogueProgressBar;
